module.exports = __webpack_public_path__ + "static/media/study 201106.59bb6358.png";